import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { IBiomarker, Biomarker } from '../Biomarker';
import { BiomarkerApi } from '../../../apis/BiomarkerApi/BiomarkerApi';

export function useGetBiomarkers() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.biomarkers],
        queryFn: async (): Promise<Biomarker[]> => {
            const result: IBiomarker[] = await BiomarkerApi.getBiomarkers();
            return result.map((biomarker) => new Biomarker(biomarker));
        },
    });
} 